// HomeButton.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function HomeButton({ label = "홈으로 가기" }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="btn btn-primary"
      onClick={() => navigate("/")}
    >
      {label}
    </button>
  );
}
